import { ViewingActivity } from "../common/video/models/Video";
import { Group } from "../user/User";
import { VideoExtraMaterial } from "./video";
import { JsonAny } from "../../src/common/Types";
import parseISO from "date-fns/parseISO";
import { SlideComment } from "./SlideComment";

//コンテンツのチャプター定義
export interface Chapter {
    id: number;
    title: number;
    description: string;
}

//コンテンツのリンク定義
export interface Link {
    id: number;
    title: number;
    link: string;
}
//tipsの定義
export interface Tip {
    id: number;
    title: number;
    description: string;
}

//コンテンツ詳細定義
export interface Slide {
    id: number;
    sourceUrl: string;
    imageUrl: string;
    fileName: string;
    title: string;
    description: string;
    presenter: string;
    presenterId: number;
    viewCount: number;
    status: string;
    tags: string[];
    comments: SlideComment[];
    extraMaterials: VideoExtraMaterial[];
    created: Date;
    viewingActivities: ViewingActivity[];
    visibleNewIcon: boolean;
    group: Group[];
    chapter: Chapter[];
    links: Link[];
    tips: Tip[];
}

/* 仮ファイル定義 */
export interface TempFile {
    keyName: string;
    fileName: string;
    url: string;
}

/* ファイルプレビューURL定義 */
export interface FilePreviewImage {
    sequence: number;
    keyName: string;
    imageUrl: string;
}

// ビデオアップロード
export interface CreateSlideIF {
    documentFile: File[];
    documentName: string[];
    content: SlideInfo;
}

export interface SlideInfo {
    keyName: string;
    title: string;
    description: string;
    presenterId: number;
    fileName: string;
    tags?: number[];
    group: number[];
    chapter: Chapter[];
    tips: Tip[];
}

// コンテンツ編集
export interface EditSlideIF {
    userId: string;
    materialId: number[];
    documentFile: File[];
    documentName: string[];
    content: SlideInfoIF;
}

export interface SlideInfoIF {
    id: number;
    keyName?: string;
    fileName: string;
    title: string;
    description: string;
    presenterId: number;
    tags: number[];
    group: number[];
    chapter: Chapter[];
    tips: Tip[];
}

export function parseSlide(json: JsonAny): Slide {
    return {
        ...json,
        created: parseISO(json.created),
    };
}

// Slideの資料アップロード定義
export interface UploadDocumentIF {
    userId: string;
    slideStockId: number;
    materialId: number[];
    documentFile: File[];
    documentName: string[];
}
